import { colors } from '../../../../../colorVars';

type Props = {
  /**
   * Size of icon in pixels
   */
  size: string;
  margin: string;
};

export const DownArrow = ({ size, margin }: Props) => {
  return (
    <svg
      x="0px"
      y="0px"
      viewBox="0 0 490 490"
      xmlSpace="preserve"
      width={size}
      height={size}
      fill={colors.red}
      style={{ margin }}
    >
      <g>
        <path
          d="M489.642,245c0-135.309-109.53-245-244.641-245S0.358,109.691,0.358,245s109.531,245,244.643,245
		S489.642,380.309,489.642,245z M149.487,176.57h199.895l-99.951,187.215L149.487,176.57z"
        />
      </g>
    </svg>
  );
};
